<template>
    <v-container v-resize="onResize">
        <v-layout v-if="!this.loading" row wrap align-center>
            <v-flex xs12 lg4>
                <h1>Ministerial Statements</h1>
            </v-flex>
            <v-flex class="pt-xs-2" xs6 sm3 offset-md6 md2>
                <count-up :endVal="items.length" text="Ministerial statements since federation" />
            </v-flex>
        </v-layout>

        <br/>

        <v-layout row wrap align-center justify-space-between>
            <v-btn-toggle v-model="chartType" class="transparent handbook_toggleButton" :mandatory="true">
                <v-tooltip top :disabled="this.$vuetify.breakpoint.name !== 'md'">
                    <template v-slot:activator="{ on }">
                        <v-btn v-on="on" class="handbook_button" :value="'perYear'">
                            <span class="long-button-text chamberButton">Ministerial Statements by year</span>
                        </v-btn>
                    </template>
                    <span>Ministerial Statements by year</span>
                </v-tooltip>
                <v-tooltip top :disabled="this.$vuetify.breakpoint.name !== 'md'">
                    <template v-slot:activator="{ on }">
                        <v-btn v-on="on" class="handbook_button" :value="'perParliament'">
                            <span class="long-button-text chamberButton">Ministerial statements by Parliament</span>
                        </v-btn>
                    </template>
                    <span>Ministerial statements by Parliament</span>
                </v-tooltip>             

                <v-tooltip top :disabled="this.$vuetify.breakpoint.name !== 'md'">
                    <template v-slot:activator="{ on }">
                        <v-btn v-on="on" class="handbook_button" :value="'byMinister'">
                            <span class="long-button-text chamberButton">Ministerial statements by Minister</span>
                        </v-btn>
                    </template>
                    <span>Ministerial statements by Minister</span>
                </v-tooltip>

                <v-tooltip top :disabled="this.$vuetify.breakpoint.name !== 'md'">
                    <template v-slot:activator="{ on }">
                        <v-btn v-on="on" class="handbook_button" :value="'byPortfolio'">
                            <span class="long-button-text chamberButton">Ministerial statements by Portfolio</span>
                        </v-btn>
                    </template>
                    <span>Ministerial statements by Portfolio</span>
                </v-tooltip>                
            </v-btn-toggle>
        </v-layout>

        <br/>

        <template v-if="!this.loading">
            <chart v-show="chartType=== 'perYear'" :chartData="chartData"/>
            <chart v-show="chartType=== 'perParliament'" :chartData="chartDataPerParliament"/>
            <div v-show="chartType === 'byMinister'">
                <v-layout row wrap align-center justify-space-between>
                <v-btn @click="chartExpanded = !chartExpanded" class="expand-button" :class="{ 'expand-button--expanded': chartExpanded }" style="margin: 0">
                    <span v-if="!chartExpanded">Expand</span>
                    <span v-else>Collapse</span>

                    <v-icon v-if="!chartExpanded">expand_more</v-icon>
                    <v-icon v-else>expand_less</v-icon>
                </v-btn>
                </v-layout>
                <br/>
                <chart :chartData="chartDataByMinister"/>
            </div>
            <div v-show="chartType === 'byPortfolio'">
                <v-layout row wrap align-center justify-space-between>
                <v-btn @click="chartExpanded = !chartExpanded" class="expand-button" :class="{ 'expand-button--expanded': chartExpanded }" style="margin: 0">
                    <span v-if="!chartExpanded">Expand</span>
                    <span v-else>Collapse</span>

                    <v-icon v-if="!chartExpanded">expand_more</v-icon>
                    <v-icon v-else>expand_less</v-icon>
                </v-btn>
                </v-layout>
                <br/>
                <chart :chartData="chartDataPerPortfolio"/>
            </div>                        
        </template>

        <v-layout v-if="!this.loading" row wrap align-center class="hidden-print-only">
            <v-flex xs12 md3 mt-4 mt-xs-2>
                <div>
                    <v-text-field :class="{mobileTextField: isMobile}" v-model="search" append-icon="search" label="Search" single-line hide-details></v-text-field>
                    <v-menu v-if="!this.loading && this.isMobile" d-inline offset-y :nudge-left="140" :close-on-content-click="true">
                        <v-btn outline small slot="activator">
                            Sort <v-icon>sort</v-icon>
                        </v-btn>
                        <v-list>
                             <v-subheader
                                >
                                Sort by:
                                </v-subheader>
                            <v-list-tile v-for="(item, index) in HEADERS" :key="item.value" @click="changeSort(item.value)">
                                <v-list-tile-title>
                                    {{ item.text }}
                                    <v-icon v-if="PAGINATION.sortBy === item.value">{{PAGINATION.descending ? 'arrow_downward':'arrow_upward'}}</v-icon>
                                </v-list-tile-title>
                            </v-list-tile>
                        </v-list>
                    </v-menu>
                </div>
            </v-flex>
        </v-layout>

        <loader v-if="loading" />       

        <br/>
        <br/>

        <div v-if="!loading"> 
            <v-data-table 
                v-if="chartType === 'perYear'"
                :headers="HEADERS"
                :footer-props="FOOTERS"
                :items="perYearData"
                item-key="year"
                :search="search"
                :rows-per-page-items="ROWS_LISTITEMS"
                :pagination.sync="PAGINATION"
                :hide-headers="isMobile || isPrint"
                :expand="expand"
                :hide-actions="isPrint"
                :disable-initial-sort="true"
                :class="{ mobileDataTable: isMobile || isPrint, 'elevation-1': true }">
                <template v-slot:items="props">
                    <tr v-if="isMobile || isPrint">
                        <td>
                            <div class="flex-content">
                                <div class="flex-item"><h3 class="pb-xs-0">{{ props.item.year }}</h3></div>
                                <div class="flex-item">{{ props.item.count }}</div>
                            </div>
                        </td>
                    </tr>
                    <tr v-else @click="props.expanded = !props.expanded">
                        <td style="padding-right: 0"><v-icon>{{ props.expanded ? 'expand_less' : 'expand_more' }}</v-icon></td>
                        <td class="text-xs-left font-weight-bold">{{ props.item.year }}</td>
                        <td class="text-xs-left">{{ props.item.count }}</td>
                    </tr>
                </template>
                <template v-slot:expand="props">
                    <div class="pa-3">                        
                        <ministerial-statements-table :items="props.item.items"
                        ></ministerial-statements-table>                                                              
                    </div>
                </template>
            </v-data-table> 
            <v-data-table
                v-if="chartType === 'perParliament'"
                :headers="byParliamentHeaders"
                :footer-props="FOOTERS"
                :items="perParliamentData"
                item-key="id"
                :search="search"
                :rows-per-page-items="ROWS_LISTITEMS"
                :pagination.sync="PAGINATION"
                :hide-headers="isMobile || isPrint"
                :expand="expand"
                :hide-actions="isPrint"
                :disable-initial-sort="true"
                :class="{ mobileDataTable: isMobile || isPrint, 'elevation-1': true }">
                <template v-slot:items="props">
                    <tr v-if="isMobile || isPrint">
                        <td>
                            <div class="flex-content">
                                <div class="flex-item"><h3 class="pb-xs-0">{{ props.item.parliament }}</h3></div>
                                <div class="flex-item">{{ props.item.count }}</div>
                            </div>
                        </td>
                    </tr>
                    <tr v-else @click="props.expanded = !props.expanded">
                        <td style="padding-right: 0"><v-icon>{{ props.expanded ? 'expand_less' : 'expand_more' }}</v-icon></td>
                        <td class="text-xs-left font-weight-bold">{{ props.item.parliament }}</td>
                        <td class="text-xs-left">{{ props.item.count }}</td>
                    </tr>
                </template>
                <template v-slot:expand="props">
                    <div class="pa-3">                        
                        <ministerial-statements-table :items="props.item.items"
                        ></ministerial-statements-table>                                                              
                    </div>
                </template>                
            </v-data-table>

            <v-data-table
                v-if="chartType === 'byPortfolio'"
                :headers="byPortfolioHeaders"
                :footer-props="FOOTERS"
                :items="byPortfolioData"
                item-key="portfolio"
                :search="search"
                :rows-per-page-items="ROWS_LISTITEMS"
                :pagination.sync="PAGINATION"
                :hide-headers="isMobile || isPrint"
                :expand="expand"
                :hide-actions="isPrint"
                :disable-initial-sort="true"
                :class="{ mobileDataTable: isMobile || isPrint, 'elevation-1': true }">
                <template v-slot:items="props">
                    <tr v-if="isMobile || isPrint">
                        <td>
                            <div class="flex-content">
                                <div class="flex-item"><h3 class="pb-xs-0">{{ props.item.portfolio }}</h3></div>
                                <div class="flex-item">{{ props.item.count }}</div>
                            </div>
                        </td>
                    </tr>
                    <tr v-else @click="props.expanded = !props.expanded">
                        <td style="padding-right: 0"><v-icon>{{ props.expanded ? 'expand_less' : 'expand_more' }}</v-icon></td>
                        <td class="text-xs-left font-weight-bold">{{ props.item.portfolio }}</td>
                        <td class="text-xs-left">{{ props.item.count }}</td>
                    </tr>
                </template>
                <template v-slot:expand="props">
                    <div class="pa-3">                        
                        <ministerial-statements-table :items="props.item.items"
                        ></ministerial-statements-table>                                                              
                    </div>
                </template>                
            </v-data-table>             

            <v-data-table 
                v-if="chartType === 'byMinister'"
                :headers="byMinisterHeaders"
                :footer-props="FOOTERS"
                :items="byMinisterData"
                item-key="minister"
                :search="search"
                :rows-per-page-items="ROWS_LISTITEMS"
                :pagination.sync="PAGINATION"
                :hide-headers="isMobile || isPrint"
                :expand="expand"
                :hide-actions="isPrint"
                :disable-initial-sort="true"
                :class="{ mobileDataTable: isMobile || isPrint, 'elevation-1': true }">
                <template v-slot:items="props">
                    <tr v-if="isMobile || isPrint">
                        <td>
                            <div class="flex-content">
                                <div class="flex-item"><h3 class="pb-xs-0">{{ props.item.minister }}</h3></div>
                                <div class="flex-item">{{ props.item.count }}</div>
                            </div>
                        </td>
                    </tr>
                    <tr v-else @click="props.expanded = !props.expanded">
                        <td style="padding-right: 0"><v-icon>{{ props.expanded ? 'expand_less' : 'expand_more' }}</v-icon></td>
                        <td class="text-xs-left font-weight-bold">{{ props.item.minister }}</td>
                        <td class="text-xs-left">{{ props.item.count }}</td>
                    </tr>
                </template>
                <template v-slot:expand="props">
                    <div class="pa-3">                        
                        <ministerial-statements-table :items="props.item.items"
                        ></ministerial-statements-table>                                                              
                    </div>
                </template>                
            </v-data-table>    
        </div>   
        <br/>
        <v-layout row wrap class="hidden-print-only">
            <v-flex xs12>
                <v-btn class="csvButton" @click="exportCsv" v-on:keyup.enter="exportCsv" color="primary">
                    <v-icon aria-hidden="true" :class="csvDownloadClass">{{csvDownloadIcon}}</v-icon>
                    <span>&nbsp;Download CSV</span>
                </v-btn>
            </v-flex>
        </v-layout>
    </v-container>
</template>

<script>    
    import print from '../../mixins/print';
    import Loader from '@/components/Loader.vue';
    import axios from 'axios';
    import CountUp from "../StatisticalInformation/CountUp.vue";
    import Chart from '../StatisticalInformation/Chart.vue';
    import MinisterialStatementsTable from '../MinisterialStatements/MinisterialStatementsTable.vue';
    window.Handbook = window.Handbook || {}
    const apiUri = window.Handbook.ApiUri || "https://localhandbookapi.aph.gov.au/";
    axios.defaults.baseURL = apiUri;

    export default {
        created() {
            this.initialiseItems();
            this.onResize();
        },
        mixins: [print],
        components: {
            Loader,
            Chart,
            CountUp,
            MinisterialStatementsTable
        },
        data() {
            return {                
                chartExpanded: false,
                expand: false,
                isMobile: false,
                search: '',
                items: [],
                loading: true,
                csvDownloading: false,
                chartType: 'perYear',
                ministersSelected: [],
                ROWS_LISTITEMS: [5, 10, 50, {
                    "text": "$vuetify.dataIterator.rowsPerPageAll",
                    "value": -1
                }],
                PAGINATION: {
                    rowsPerPage: this.$store.state.ROWS_PER_PAGE,
                    sortBy: 'year',
                    descending: true
                },
                HEADERS: [
                {
                    text: '',
                    value: 'year',
                    align: 'left',
                    sortable: false,
                    width: '10px'
                },
                {
                    text: 'Year',
                    value: 'year',
                    align: 'left',
                    sortable: true,
                },
                {
                    text: 'Count',
                    value: 'count',
                    align: 'left',
                    sortable: true
                },
                ],
                byParliamentHeaders: [
                {
                    text: '',
                    value: 'id',
                    align: 'left',
                    sortable: false,
                    width: '10px'
                },                    
                {
                    text: 'Parliament',
                    value: 'id',
                    align: 'left',
                    sortable: true,
                },
                {
                    text: 'Count',
                    value: 'count',
                    align: 'left',
                    sortable: true
                },
                ],
                byPortfolioHeaders: [
                {
                    text: '',
                    value: 'portfolio',
                    align: 'left',
                    sortable: false,
                    width: '10px'
                },                    
                {
                    text: 'Portfolio',
                    value: 'portfolio',
                    align: 'left',
                    sortable: true,
                },
                {
                    text: 'Count',
                    value: 'count',
                    align: 'left',
                    sortable: true
                },
                ],                
                byMinisterHeaders: [
                {
                    text: '',
                    value: 'minister',
                    align: 'left',
                    sortable: false,
                    width: '10px'
                },                    
                {
                    text: 'Minister',
                    value: 'minister',
                    align: 'left',
                    sortable: true,
                },
                {
                    text: 'Count',
                    value: 'count',
                    align: 'left',
                    sortable: true
                },
                ],
                FOOTERS: {
                    showFirstLastPage: true,
                    firstIcon: 'mdi-arrow-collapse-left',
                    lastIcon: 'mdi-arrow-collapse-right',
                    prevIcon: 'mdi-minus',
                    nextIcon: 'mdi-plus',
                },
            }
        },
        computed: {
            csvDownloadIcon(){
                return this.csvDownloading ? 'cached' : 'text_snippet';
            },
            csvDownloadClass(){
                let csvClass = 'mr-1';
                if (this.csvDownloading){
                    csvClass = csvClass + ' loading'
                }
                return csvClass;
            },
            ministers() {
                return [...new Set(this.items.map(i => i.Minister.DisplayName))].sort();
            },
            perYearData() {
                const temp = this.items;
                let data = [];

                for (let i = 1901; i < new Date().getFullYear() + 1; i++){
                    data.push({ 
                        year: i, 
                        count: temp.filter(d => new Date(d.Date).getFullYear() === i).length,
                        items: temp.filter(d => new Date(d.Date).getFullYear() === i)
                        });
                }
                return data.reverse();
            },
            perParliamentData() {              
                // Create date ranges based on selected parliaments
                let parliaments = this.$store.getters.GET_PARLIAMENTS_ORDERED;            
                // go through each parliament and generate a list
                return parliaments.map(p => {
                    const items = this.items.filter(i => {                        
                        const statementDate = new Date(i.Date);
                        const startDate = p.DateOpening ? new Date(p.DateOpening) : new Date(p.DateElection);
                        const endDate = p.DateDissolution ? new Date(p.DateDissolution) : new Date();
                        return statementDate >= startDate && statementDate <= endDate;
                    });                 

                    return ({
                        id: p.PID,
                        parliament: p.Name,
                        count: items.length,
                        items
                    });
                });
            },
            // return an array with a list of objects of the shape { minister: 'name', count: 0 }
            byMinisterData() {
                const countByMinister = this.items.reduce((acc, curr) => {
                const ministerName = curr.Minister.DisplayName;
                acc[ministerName] = (acc[ministerName] || 0) + 1;
                return acc;
                }, {});

                const ministers = Object.entries(countByMinister)
                .sort((a, b) => b[1] - a[1]) // Sort by count, descending order
                .map(([name]) => name); // Take only the names

                return ministers.map(m => ({ 
                    minister: m, 
                    items: this.items.filter(i => i.Minister.DisplayName === m),
                    count: this.items.filter(i => i.Minister.DisplayName === m).length 
                }));
            },
            byPortfolioData() {
                const groupByPortfolio = (statements) => {
                    const grouped = {};

                    statements.forEach(statement => {
                        statement.Portfolios.forEach(portfolio => {
                            if (!grouped[portfolio]) {
                                grouped[portfolio] = [];
                            }
                            grouped[portfolio].push(statement);
                        });
                    });

                    return Object.keys(grouped)
                        .sort()
                        .map(portfolio => ({
                        portfolio: portfolio,
                        items: grouped[portfolio],
                        count: grouped[portfolio].length
                    }));
                }
                return groupByPortfolio(this.items);
            },            
            chartData() {
                const temp = this.items.map(i => new Date(i.Date).getFullYear());

                let data = [];

                for (let i = 1901; i < new Date().getFullYear() + 1; i++){
                    data.push(temp.filter(d => d === i).length);
                }

                const plotLines = this.$store.getters.GET_PARLIAMENTS_ORDERED
                    .map(p => ({
                        value: (new Date(p.DateElection).getFullYear()).valueOf(),
                        dashStyle: 'shortdash',
                        color: '#CCD6EB',
                        label: {
                            text: p.PID,
                            y: 0
                        }}));

                return {
                title: {
                    text: 'Number of ministerial statements per year'
                },

                yAxis: {
                    title: {
                        text: 'Number of ministerial statements'
                    }
                },
                xAxis: [{
                    plotLines,
                },
                {
                    title: {
                        text: 'Parliaments'
                    },
                    offset: 15,
                    lineColor: 'transparent',
                    opposite: true
                }
                ],

                plotOptions: {
                    series: {
                        label: {
                            connectorAllowed: false
                        },
                        pointStart: 1901
                    }
                },
                series: 
                [
                    {
                        name: 'Ministerial statements',
                        data
                    },
                ]
                }
            },
            chartDataPerParliament() {
                const data = this
                    .perParliamentData
                    .map(p => p.count)
                    .reverse();

                return {
                title: {
                    text: 'Number of ministerial statements per Parliament'
                },

                yAxis: {
                    title: {
                        text: 'Number of ministerial statements'
                    }
                },
                plotOptions: {
                    series: {
                        label: {
                            connectorAllowed: false
                        },
                        pointStart: 1
                    }
                },
                series: 
                [
                    {
                        name: 'Ministerial statements',
                        data
                    },
                ]
                }
            },
            chartDataByMinister() {
                const countByMinister = this.items.reduce((acc, curr) => {
                const ministerName = curr.Minister.DisplayName;
                acc[ministerName] = (acc[ministerName] || 0) + 1;
                return acc;
                }, {});

                let ministers = Object.entries(countByMinister)
                .sort((a, b) => b[1] - a[1]) // Sort by count, descending order
                .map(([name]) => name); // Take only the names

                if (!this.chartExpanded) {
                    ministers = ministers.slice(0, 15);
                }

                const data = ministers.map(m => ({
                    y: this.items.filter(i => i.Minister.DisplayName === m).map(i => new Date(i.Date).getFullYear()).length
                }));

                return {
                chart: {
                    type: 'bar',
                    height: this.items.length > 0 ? ( this.chartExpanded ? ministers.length * 20 : ministers.length * 30 ) : null
                },
                title: {
                    text: 'Ministerial statements by minister' + (this.chartExpanded ? '' : ' (top 15)')
                },

                yAxis: {
                    title: {
                        text: 'Number of ministerial statements'
                    }
                },
                xAxis:{
                    categories: ministers
                },
                plotOptions: {
                },
                series: [{
                    name: 'Ministerial statements',
                    data
                }]
                }
            },
            chartDataPerPortfolio() {
                let portfolioDataSorted = [...this
                    .byPortfolioData]
                    .sort((a, b) => b.items.length - a.items.length)

                if (!this.chartExpanded) {
                    portfolioDataSorted = portfolioDataSorted.slice(0, 15);
                }

                const data = portfolioDataSorted
                    .map(p => p.items.length);                    

                const portfolios = portfolioDataSorted
                    .map(p => p.portfolio);

                return {
                chart: {
                    type: 'bar',
                    height: this.items.length > 0 ? ( this.chartExpanded ? portfolios.length * 20 : portfolios.length * 30 ) : null
                },
                title: {
                    text: 'Ministerial statements by portfolio' + (this.chartExpanded ? '' : ' (top 15)')
                },

                yAxis: {
                    title: {
                        text: 'Number of ministerial statements'
                    }
                },
                xAxis:{
                    categories: portfolios
                },
                plotOptions: {
                },
                series: [{
                    name: 'Ministerial statements',
                    data
                }]
                }
            },            
        },
        mounted() {
            this.onResize();
            //Set page to 10 on mobile, only on mount
            if (this.isMobile){
                this.PAGINATION.rowsPerPage = 10;
            }
        },
        methods: {
            onResize() {
                if (window.innerWidth < 1060) {
                    this.isMobile = true;
                }
                else {
                    this.isMobile = false;
                }
            },
            changeSort(column) {
                if (this.PAGINATION.sortBy === column) {
                    this.PAGINATION.descending = !this.PAGINATION.descending
                } 
                else {
                    this.PAGINATION.sortBy = column
                    this.PAGINATION.descending = false
                }
            },
            deleteMinistersSelected(item) {
                this.ministersSelected = this.ministersSelected.filter(i => i !== item);
            },
            initialiseItems() {
                this.loading = true;
                const url = 'MinisterialStatements/MinisterialStatements';
                axios.get(`api/${url}`)
                    .then(response => {
                        this.items = response.data;
                        this.loading = false;
                    });
            },
            exportCsv() {
                switch(this.chartType) {
                    case 'perYear': 
                        this.exportByYearCsv();
                        break;
                    case 'perParliament':      
                        this.exportParliamentsCsv();
                        break;                  
                    case 'byMinister':                        
                        this.exportMinistersCsv();       
                        break;
                    case 'byPortfolio':
                        this.exportPortfoliosCsv();
                        break;                    
                }
            },
            exportByYearCsv() {
                this.$gtag.event('ministerial statements download csv', {
                    'event_category': 'downloads',
                    'event_label': `ministerial statements per year csv download`,
                    'value': 1
                });

                this.csvDownloading = true;
                const records = this.perYearData.map(i => 
                    ({ 
                        Year: i.year,
                        Count: i.count
                    }));
                let headers = this.HEADERS.map(h => h.text);
                const filename = 'Ministerial statements per year';
                const comment = `Data current as of ${(new Date()).toLocaleDateString()}`;
                this.$store.dispatch('GETCSV', { DATA: records, HEADERS: headers, FILENAME: filename, COMMENT: comment })
                    .catch(this.showError)
                    .finally(() => this.csvDownloading = false);
            },
            exportParliamentsCsv() {
                this.$gtag.event('ministerial statements download csv', {
                    'event_category': 'downloads',
                    'event_label': `ministerial statements by Parliament csv download`,
                    'value': 1
                });

                this.csvDownloading = true;
                const records = this.perParliamentData.map(i => 
                    ({ 
                        Parliament: i.parliament,
                        Count: i.count
                    }));
                let headers = this.byParliamentHeaders.map(h => h.text);
                const filename = 'Ministerial statements by Parliament';
                const comment = `Data current as of ${(new Date()).toLocaleDateString()}`;
                this.$store.dispatch('GETCSV', { DATA: records, HEADERS: headers, FILENAME: filename, COMMENT: comment })
                    .catch(this.showError)
                    .finally(() => this.csvDownloading = false);
            },            
            exportMinistersCsv() {
                this.$gtag.event('ministerial statements download csv', {
                    'event_category': 'downloads',
                    'event_label': `ministerial statements by minister csv download`,
                    'value': 1
                });

                this.csvDownloading = true;
                const records = this.byMinisterData.map(i => 
                    ({ 
                        Minister: i.minister,
                        Count: i.count
                    }));
                let headers = this.byMinisterHeaders.map(h => h.text);
                const filename = 'Ministerial statements by minister';
                const comment = `Data current as of ${(new Date()).toLocaleDateString()}`;
                this.$store.dispatch('GETCSV', { DATA: records, HEADERS: headers, FILENAME: filename, COMMENT: comment })
                    .catch(this.showError)
                    .finally(() => this.csvDownloading = false);
            },
            exportPortfoliosCsv() {
                this.$gtag.event('ministerial statements download csv', {
                    'event_category': 'downloads',
                    'event_label': `ministerial statements by portfolio csv download`,
                    'value': 1
                });

                this.csvDownloading = true;
                const records = this.byPortfolioData.map(i => 
                    ({ 
                        Minister: i.portfolio,
                        Count: i.ministerialStatements.length
                    }));
                let headers = this.byPortfolioHeaders.map(h => h.text);
                const filename = 'Ministerial statements by portfolio';
                const comment = `Data current as of ${(new Date()).toLocaleDateString()}`;
                this.$store.dispatch('GETCSV', { DATA: records, HEADERS: headers, FILENAME: filename, COMMENT: comment })
                    .catch(this.showError)
                    .finally(() => this.csvDownloading = false);
            }            
        },
    }
</script>